import { Stack } from "@altimateai/lego";
import { useQuery } from '@tanstack/react-query';
import { getConnections } from "@/helpers/apis";
import { Connection, CommonIntegrationInstance } from "./mcpSlice";
import ConnectionItem from "./ConnectionItem";
import { ConnectionsQueryKey } from "./constants";

interface ConnectionsListProps {
  integration: CommonIntegrationInstance;
  onSelect?: (connectionId: string, integrationId: string) => void;
  selectedConnectionId?: string;
}

const ConnectionsList = ({ integration, onSelect, selectedConnectionId }: ConnectionsListProps) => {
  const { data: connectionsData = { connections: [] }, isLoading } = useQuery({
    queryKey: [ConnectionsQueryKey],
    queryFn: () => getConnections(),
  });

  const connections = connectionsData.connections.filter(
    connection => connection.integration_id === integration.id
  );

  if (isLoading) return null;

  if (connections.length === 0) return null;

  return (
    <Stack direction="column" className="al-gap-2">
      {connections.map((connection: Connection) => (
        <ConnectionItem
          key={connection.id}
          connection={connection}
          integration={integration}
          onSelect={onSelect}
          isSelected={connection.id === selectedConnectionId}
        />
      ))}
    </Stack>
  );
};

export default ConnectionsList;
